import { type CarList } from '../_types/Car';
import { baseUrl } from '../vars';
import mockListCar from './ListCar';

const mockCarList: CarList = {
    facets: {
        aufbau: {},
        aufbauAll: {},
        bereich: {},
        bereichAll: {},
        ez: {},
        ezAll: {},
        farben: {},
        farbenAll: {},
        fd: {},
        fdAll: {},
        firmen: {},
        firmenAll: {},
        getriebe: {},
        getriebeAll: {},
        hersteller: {},
        herstellerAll: {},
        km: {},
        kmAll: {},
        Leistung: {},
        LeistungAll: {},
        modell: {},
        modellAll: {},
        MotorG: {},
        MotorGAll: {},
        Ort: {},
        OrtAll: {},
        preis: {},
        preisAll: {},
        rate: {},
        rateAll: {},
        siegel: {},
        siegelAll: {},
        standort: {},
        standortAll: {},
        tags: {},
        tagsAll: {},
    },
    searchResult: {
        numFound: 7,
        cars: [
            mockListCar.null,
            mockListCar.empty,
            mockListCar.nullContentLevel0,
            mockListCar.emptyContentLevel0,
            { ...mockListCar.nullContentLevel1, id: 1 },
            { ...mockListCar.emptyContentLevel1, id: 2 },
            { ...mockListCar.full, id: 3 },
        ],
    },
};

const mockupCarList: CarList = {
    facets: {
        aufbau: {},
        aufbauAll: {},
        bereich: {},
        bereichAll: {},
        ez: {},
        ezAll: {},
        farben: {},
        farbenAll: {},
        fd: {},
        fdAll: {},
        firmen: {},
        firmenAll: {},
        getriebe: {},
        getriebeAll: {},
        hersteller: {},
        herstellerAll: {},
        km: {},
        kmAll: {},
        Leistung: {},
        LeistungAll: {},
        modell: {},
        modellAll: {},
        MotorG: {},
        MotorGAll: {},
        Ort: {},
        OrtAll: {},
        preis: {},
        preisAll: {},
        rate: {},
        rateAll: {},
        siegel: {},
        siegelAll: {},
        standort: {},
        standortAll: {},
        tags: {},
        tagsAll: {},
    },
    searchResult: {
        numFound: 3,
        cars: [
            { ...mockListCar.full, id: 1, bilder: { anzahl: 1, url: [`${baseUrl}/static/media/placeholder.jpg`, `${baseUrl}/static/media/placeholder.jpg`] } }, // { ...mockListCar.full, id: 1, bilder: { url: ['https://p.autohaus-digital.de/s/v3/imgc/9800/18858286/1731426560691/640', 'https://p.autohaus-digital.de/s/v3/imgc/9800/18858286/1731426560691/640'] } },
            { ...mockListCar.full, id: 2, bilder: { anzahl: 1, url: [`${baseUrl}/static/media/placeholder.jpg`, `${baseUrl}/static/media/placeholder.jpg`] } },
            { ...mockListCar.full, id: 3, bilder: { anzahl: 1, url: [`${baseUrl}/static/media/placeholder.jpg`, `${baseUrl}/static/media/placeholder.jpg`] } },
        ],
    },
};

export { mockCarList, mockupCarList };
